import { hookFactory } from "../helpers/hookFactory";

/**
 * React hook to get user's account methods
 *
 * @returns Saleor's user's account methods
 */
export const useUser = hookFactory("user");
